// pp-calc-kit-arranque.js — Tu Kit de Empaque para Empezar a Vender en Línea
// (/pages/kit-de-empaque-para-tu-tienda-online)
//
// Arma la lista de compra inicial de empaque para alguien que apenas abre su
// tienda en línea. La receta es EDITORIAL de Para Paquetes (no una fórmula
// física): cantidades = pedidos × meses × 1.15 de colchón, empaque principal
// según lo que vende, y los consumibles que nadie anota (cinta, etiquetas,
// plumón). El kit se presenta como sugerencia ajustable, y el costo total NO
// se calcula: los precios cambian y se ven al día en cada colección.
//
// Aritmética pura probada en tests/calc-kit-arranque.test.mjs.
(function (root) {
  'use strict';

  var COLCHON = 1.15;              // 15% de margen sobre la expectativa
  var CAJAS_POR_ROLLO = 60;        // cajas selladas por rollo de cinta
  var MIN_ROLLOS_CINTA = 2;        // mínimo cuando el empaque se sella con cinta
  var BURBUJA_M_POR_PEDIDO = 0.5;  // metros de burbuja por pedido frágil
  var ETIQUETAS_POR_ROLLO = 500;   // etiquetas de FRÁGIL por rollo
  var PEDIDOS_POR_PLUMON = 300;    // un plumón aguanta ~300 rotulados

  // Qué empaque principal le toca a cada giro. `autosella` = bolsas/sobres
  // con cinta propia (la cinta del kit queda de respaldo). `burbuja` = el
  // principal ya viene en pareja con burbuja (cosmética), traiga o no la
  // casilla de frágil marcada. `kraft` = relleno kraft para carga variada.
  var TIPOS = {
    ropa: { principal: 'bolsas', autosella: true, burbuja: false, kraft: false },
    accesorios: { principal: 'sobres', autosella: true, burbuja: false, kraft: false },
    cosmetica: { principal: 'cajas_chicas', autosella: false, burbuja: true, kraft: false },
    hogar: { principal: 'cajas_surtidas', autosella: false, burbuja: false, kraft: true }
  };

  // Concepto visible y sustantivo de cada renglón — las cantidades JAMÁS se
  // muestran sin sustantivo ("120 bolsas", "2 rollos", nunca "120").
  var CATALOGO = {
    bolsas: { concepto: 'Bolsas para Envíos', unidad: ['bolsa', 'bolsas'] },
    sobres: { concepto: 'Sobres con Burbuja', unidad: ['sobre', 'sobres'] },
    cajas_chicas: { concepto: 'Cajas de Cartón Chicas', unidad: ['caja', 'cajas'] },
    cajas_surtidas: { concepto: 'Cajas de Cartón Surtidas', unidad: ['caja', 'cajas'] },
    burbuja: { concepto: 'Rollo de Burbuja', unidad: ['metro', 'metros'] },
    kraft: { concepto: 'Papel Kraft para Relleno', unidad: ['metro', 'metros'] },
    cinta: { concepto: 'Cinta Adhesiva para Empaque', unidad: ['rollo', 'rollos'] },
    etiquetas: { concepto: 'Etiquetas de Frágil', unidad: ['rollo de 500', 'rollos de 500'] },
    plumon: { concepto: 'Plumón para Rotular', unidad: ['plumón', 'plumones'] }
  };

  // Entradas: pedidosMes (número), meses (1|2|3), tipo
  // ('ropa'|'accesorios'|'cosmetica'|'hogar'), fragil (truthy ⇒ frágil).
  // Devuelve { base, pedidosTotales, items: [{ id, cantidad }] } o null.
  function calcularKit(e) {
    if (!e) return null;
    var pedidos = num(e.pedidosMes);
    var meses = num(e.meses);
    var t = TIPOS[e.tipo];
    if (pedidos === null || pedidos <= 0 || meses === null || meses <= 0 || !t) return null;

    var fragil = !!e.fragil;
    var base = Math.ceil(pedidos * meses * COLCHON);
    var items = [];

    items.push({ id: t.principal, cantidad: base });

    if (fragil || t.burbuja) {
      items.push({ id: 'burbuja', cantidad: Math.ceil(base * BURBUJA_M_POR_PEDIDO) });
    }
    if (t.kraft) {
      items.push({ id: 'kraft', cantidad: Math.ceil(base * BURBUJA_M_POR_PEDIDO) });
    }

    // Cinta: 1 rollo por cada 60 cajas selladas, mínimo 2. Bolsas y sobres
    // se sellan solos ⇒ un solo rollo de respaldo.
    items.push({
      id: 'cinta',
      cantidad: t.autosella ? 1 : Math.max(MIN_ROLLOS_CINTA, Math.ceil(base / CAJAS_POR_ROLLO)),
      respaldo: t.autosella
    });

    if (fragil) {
      items.push({ id: 'etiquetas', cantidad: Math.ceil(base / ETIQUETAS_POR_ROLLO) });
    }

    items.push({ id: 'plumon', cantidad: Math.max(1, Math.ceil(base / PEDIDOS_POR_PLUMON)) });

    return {
      base: base,
      pedidosTotales: Math.round(pedidos * meses),
      items: items
    };
  }

  function num(x) {
    if (x === null || x === undefined || x === '') return null;
    var v = Number(String(x).replace(',', '.'));
    return isFinite(v) ? v : null;
  }

  root.PPKitArranque = {
    TIPOS: TIPOS,
    CATALOGO: CATALOGO,
    calcularKit: calcularKit
  };
})(typeof window !== 'undefined' ? window : globalThis);

// ── Wiring de la página (no corre en tests de node) ────────────────────────
(function () {
  'use strict';
  if (typeof document === 'undefined') return;

  function listo(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  listo(function () {
    var raiz = document.querySelector('[data-pp-calc-kit-arranque]');
    if (!raiz) return;
    var C = window.PPKitArranque;
    var $ = function (sel) { return raiz.querySelector(sel); };
    var form = $('form');
    var out = $('[data-calc-resultado]');

    // Links a colecciones emitidos por Liquid (id de renglón → url). Si una
    // colección no existiera, su valor llega null y el concepto sale sin link.
    var LINKS = {};
    try {
      var nodo = $('[data-kit-links]');
      if (nodo) LINKS = JSON.parse(nodo.textContent) || {};
    } catch (_) { LINKS = {}; }

    function telemetria(inputs, resultado) {
      try {
        var KEY = 'sb_publishable_48y6S7h2eQ-9uTF7pCNJNQ_Q0mz8VVX';
        fetch('https://dhygbnysealeblqorjts.supabase.co/functions/v1/calc-telemetria', {
          method: 'POST',
          keepalive: true,
          headers: { 'Content-Type': 'application/json', 'apikey': KEY, 'Authorization': 'Bearer ' + KEY },
          body: JSON.stringify({ calculadora: 'kit_arranque', inputs: inputs, resultado: resultado })
        }).catch(function () {});
      } catch (_) { /* la telemetría jamás rompe la calculadora */ }
    }

    function fmt(n) {
      return n.toLocaleString('es-MX', { maximumFractionDigits: 0 });
    }

    function correr(conTelemetria) {
      var f = new FormData(form);
      var datos = {
        pedidosMes: f.get('pedidos'),
        tipo: f.get('tipo'),
        fragil: f.get('fragil') !== null,
        meses: f.get('meses')
      };
      var r = C.calcularKit(datos);
      pintar(r);
      if (conTelemetria && r) {
        telemetria(
          { pedidos_mes: Number(datos.pedidosMes) || null, meses: Number(datos.meses) || null, fragil: datos.fragil ? 1 : 0 },
          { items: r.items.length }
        );
      }
    }

    function pintar(r) {
      if (!out) return;
      out.hidden = false;
      if (!r) {
        out.innerHTML = '<p class="pp-calc__error">Captura cuántos pedidos esperas al mes (mayor a cero) para armar tu kit.</p>';
        return;
      }

      out.innerHTML = '<div class="pp-calc__veredicto pp-calc__veredicto--ok">' +
        '<p class="pp-calc__veredicto-titulo">Tu kit para ' + fmt(r.pedidosTotales) + ' pedidos está listo — todo en una sola compra</p>' +
        '<p class="pp-calc__veredicto-dato">Kit sugerido por Para Paquetes — ajústalo a tu producto. Las cantidades ya traen un colchón del 15%: material para <strong>' + fmt(r.base) + ' pedidos</strong>.</p>' +
        '</div>';

      // Los renglones del kit se construyen con createElement/textContent —
      // los hrefs vienen de la lista que emitió Liquid, nunca de strings
      // concatenados a innerHTML.
      var dl = document.createElement('dl');
      dl.className = 'pp-calc__detalle';
      r.items.forEach(function (item) {
        var info = C.CATALOGO[item.id];
        if (!info) return;
        var fila = document.createElement('div');
        fila.className = 'pp-calc__detalle-fila';

        var dt = document.createElement('dt');
        var url = LINKS[item.id];
        if (typeof url === 'string' && url) {
          var a = document.createElement('a');
          a.href = url;
          a.textContent = info.concepto;
          dt.appendChild(a);
        } else {
          dt.textContent = info.concepto;
        }
        if (item.respaldo) dt.appendChild(document.createTextNode(' (de respaldo — tu empaque se sella solo)'));

        var dd = document.createElement('dd');
        dd.textContent = fmt(item.cantidad) + ' ' + info.unidad[item.cantidad === 1 ? 0 : 1];

        fila.appendChild(dt);
        fila.appendChild(dd);
        dl.appendChild(fila);
      });
      out.appendChild(dl);

      var nota = document.createElement('p');
      nota.className = 'pp-calc__nota';
      nota.textContent = 'El costo total no lo calculamos aquí a propósito: los precios cambian, y los ves al día en cada colección. Cada concepto lleva a la suya para que armes el carrito con precios reales.';
      out.appendChild(nota);
    }

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      correr(true);
      if (out) out.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });

    // Cosmética casi siempre viaja frágil: elegirla pre-marca la casilla
    // (el usuario la puede desmarcar después si su producto aguanta).
    var selTipo = form.querySelector('[name="tipo"]');
    var chkFragil = form.querySelector('[name="fragil"]');
    if (selTipo && chkFragil) {
      selTipo.addEventListener('change', function () {
        if (selTipo.value === 'cosmetica') chkFragil.checked = true;
      });
    }

    var timerRecalc = null;
    function recalcEnVivo() {
      if (!out || out.hidden) return;
      clearTimeout(timerRecalc);
      timerRecalc = setTimeout(function () { correr(false); }, 350);
    }
    form.addEventListener('input', recalcEnVivo);
    form.addEventListener('change', recalcEnVivo);
  });
})();
